import React from "react";
import "./Insight.scss";

type Props = {
    question: string;
    text: string;
    setText: (text: string) => any;
};

const Insight: React.FC<Props> = (props) => {
    return (
        <div className="insight">
            <div className="insight__question">
                <p>{props.question}</p>
                {/* <p style={{ color: "#ccc" }}>Max. 50 words</p> */}
            </div>
            <textarea
                style={{ marginBottom: 12 }}
                value={props.text}
                onChange={(event) => {
                    props.setText(event.target.value);
                }}
            />
        </div>
    );
};

export default Insight;
